// src/pages/TermsAndConditions.js
import React from 'react';
import { Link } from 'react-router-dom';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="legal-page">
      {/* Page Header */}
      <header className="legal-header">
        <div className="legal-header-content">
          <Link to="/" className="legal-back-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
            Back to Home
          </Link>

          <h1 className="legal-title">Terms &amp; Conditions</h1>
          <p className="legal-subtitle">
            Please read these terms carefully before using QSLOT. By using our
            platform, you agree to be bound by these terms.
          </p>
        </div>
      </header>

      {/* Content */}
      <main className="legal-container">
        {/* 1. Acceptance of Terms */}
        <section className="legal-section">
          <h2 className="legal-section-title">1. Acceptance of Terms</h2>
          <p>
            QSLOT is an internet-based Sports Venue, tournament and Car Wash
            Booking portal owned and operated by <strong>Fewas Technologies Private Limited</strong>,
            a company incorporated under Companies Act, 2013, with its registered
            office at No.32, Masakalipalayam Road, Lakshmipuram 4th Street,
            Peelamedu, Coimbatore – 641004, Tamil Nadu.
          </p>
          <p>
            Through QSLOT, QSLOT shall provide the "User" Sporting Venue-related
            information, tournament enrolment, pricing, availability and Booking
            facilities for the same, Car Wash Booking across cities and rural
            areas throughout India ("Service"), as more particularly described
            and defined in the terms of service ("TOS") relating to such
            Service. This Service may be availed by the User, his family members.
          </p>
          <p>
            This User Agreement ("Agreement") sets out the terms and conditions
            on which QSLOT shall provide the Services to the User through the
            QSLOT. In addition to this Agreement and depending on the Services
            opted for by the User, the User shall be required to read and accept
            the relevant TOS for such Service, which may be updated or modified
            by QSLOT from time to time. Such TOS shall be deemed to be a part of
            this Agreement and in the event of a conflict between such TOS and
            this Agreement, the terms of this Agreement shall prevail.
          </p>
          <p>
            Use of the QSLOT is offered to the User conditioned on acceptance
            without modification of all the terms, conditions and notices
            contained in this Agreement and the TOS, as may be posted on the
            QSLOT from time to time. For the removal of doubts, it is clarified
            that use of the QSLOT by the User constitutes an acknowledgement and
            acceptance by the User of this Agreement and the TOS.
          </p>
          <p>
            Additionally, the Service Provider may provide terms and guidelines
            that govern particular features, offers or the operating rules and
            policies applicable to each Service (for example, slots, gift
            vouchers, etc.). The User shall be responsible for ensuring
            compliance with the terms and guidelines or operating rules and
            policies of the Service Provider with whom the User elects to deal,
            including terms and conditions set forth in a Service Providers. In
            the event that any of the terms, conditions and notices contained in
            this Agreement or the TOS conflict with the additional/other terms
            and guidelines specified by the Service Provider, then the latter
            terms/guidelines shall prevail.
          </p>

          <h3 className="legal-subsection-title">1.1 Terms of Use for The App</h3>
          <p>
            These Terms of Use govern your access and use of The App ("QSlot"),
            including all services and transactions offered through the app. By
            using the App, you agree to comply with these Terms of Use, the
            Privacy Policy, and any other terms and conditions appearing on the
            App. If you do not agree with these Terms, please discontinue use of
            the App immediately. You may also terminate your agreement with us
            at any time by deletion of data through link provided to user.
          </p>

          <h3 className="legal-subsection-title">1.2 Condition of Use</h3>
          <p>
            The terms "we" and "us" refer to The App, and "you" or "User" refers
            to the person or entity accessing or using the App. For clarity,
            singular terms may include plural, and vice versa. The following key
            terms are defined within these Terms of Use:
          </p>
          <ul className="legal-list">
            <li>
              <strong>"Agreement"</strong> refers to the agreement between you
              and The App, consisting of these Terms of Use, your booking order,
              and booking confirmation.
            </li>
            <li>
              <strong>"Services"</strong> refers to the booking of turf slots/
              enrolment of Tournament/ Car Wash Booking available through the App.
            </li>
            <li>
              <strong>"Booking Order"</strong> refers to an order placed for
              services via the App.
            </li>
          </ul>

          <h3 className="legal-subsection-title">1.3 User Registration and Account</h3>
          <p>
            To use the App and purchase services, you must create an account
            with valid details such as name, email, Phone number and payment
            information. We reserve the right to accept or reject new
            registrations and can cancel accounts at our discretion. You are
            responsible for maintaining the confidentiality of your account and
            password.
          </p>

          <h3 className="legal-subsection-title">1.4 Payment</h3>
          <p>
            Booking Orders made through the App are subject to acceptance by The
            App. Once accepted, a Booking Confirmation will be provided, and the
            Agreement will be completed once payment is processed. Payments can
            be made via UPI, Net Banking, Wallet, or Online Payment methods.
            Digital coupons and discount codes may also be used for qualifying
            purchases, subject to their specific terms.
          </p>

          <h3 className="legal-subsection-title">1.5 Cancellations and Refunds</h3>
          <p>
            Cancellations are governed by the cancellation policies of the
            respective Turf / Car Wash / Tournament. You may initiate
            cancellations via your booking ticket, with the refund credited to
            your payment source within 5-7 working days. Cancellations and
            refunds are subject to approval based on the respective merchant's
            policy.
          </p>

          <h3 className="legal-subsection-title">1.6 Errors and Corrections</h3>
          <p>
            The App strives to provide accurate listings and pricing. However,
            errors (e.g., in pricing or availability) may occur. In such cases,
            The App reserves the right to correct any errors, even after a
            Booking Order is placed, and will refund the payment if the order is
            cancelled due to these errors.
          </p>

          <h3 className="legal-subsection-title">1.7 Location and Data Collection</h3>
          <p>
            By using the App, you consent to The App accessing your current
            location to show nearby turfs / the carwash and nearby tournaments
            and improve service functionality. No personal data other than your
            first name, last name, phone number and email address is collected.
            The App uses third-party services like Google Analytics and Payment
            Gateways that may collect information.
          </p>

          <h3 className="legal-subsection-title">1.8 Privacy and Security</h3>
          <p>
            The App takes steps to protect your information and employs
            encryption and secure systems for data transmission. However, no
            system is entirely secure, and we cannot guarantee 100% protection
            against data breaches. Refer to our Privacy Policy for more
            information on how we collect, use, and protect your data.
          </p>

          <h3 className="legal-subsection-title">1.9 Prohibited Activities</h3>
          <p>
            Users are prohibited from engaging in activities such as
            unauthorized access, system penetration attempts, spreading malware,
            spamming, and other activities that may disrupt the proper
            functioning of the App or violate the rights of third parties.
          </p>

          <h3 className="legal-subsection-title">1.10 Fraud Protection and Compliance</h3>
          <p>
            We may share your information for fraud protection, credit risk
            reduction, or to comply with legal obligations. Any fraudulent
            activities will be reported to the relevant authorities, and legal
            action will be taken.
          </p>

          <h3 className="legal-subsection-title">1.11 Governing Law</h3>
          <p>
            These Terms of Use are governed by Indian law. Both parties submit
            to the exclusive jurisdiction of the Indian courts for any disputes
            related to these Terms.
          </p>
        </section>

        {/* 2. Modification of Terms */}
        <section className="legal-section">
          <h2 className="legal-section-title">2. Modification of Terms</h2>
          <p>
            QSLOT reserves the right to change the terms, conditions and notices
            under which the Services are offered through the QSLOT, including
            but not limited to the charges for the Services provided through the
            QSLOT. The User shall be responsible for regularly reviewing these
            terms and conditions.
          </p>
        </section>

        {/* 3. Privacy Policy */}
        <section className="legal-section">
          <h2 className="legal-section-title">3. Privacy Policy</h2>
          <p>
            The User hereby consents, expresses and agrees that he has read and
            fully understands the Privacy Policy of QSLOT in respect of the
            QSLOT. The User further consents that the terms and contents of such
            Privacy Policy are acceptable to him.
          </p>
          <p>
            Any customer grievances can be reported through the email ID
            specifically dedicated to address all customer concerns:{' '}
            <a href="mailto:support@queeslot.com">support@queeslot.com</a>
          </p>
        </section>

        {/* 4. Limited User */}
        <section className="legal-section">
          <h2 className="legal-section-title">4. Limited User</h2>
          <p>
            The User agrees and undertakes not to sell, trade or resell or
            exploit for any commercial purposes, any portion of the Service. For
            the removal of doubt, it is clarified that the QSLOT is not for
            commercial use but is specifically meant for personal use only.
          </p>
          <p>
            The User further agrees and undertakes not to reverse engineer,
            modify, copy, distribute, transmit, display, perform, reproduce,
            publish, license, create derivative works from, transfer, or sell
            any information, software, products or services obtained from the
            QSLOT. Limited reproduction and copying of the content of the QSLOT
            is permitted provided that QSLOT's name is stated as the source. For
            the removal of doubt, it is clarified that unlimited or wholesale
            reproduction, copying of the content for commercial or non-commercial
            purposes and unwarranted modification of data and information within
            the content of the QSLOT is not permitted.
          </p>
        </section>

        {/* 5. Disclaimer of Warranties */}
        <section className="legal-section">
          <h2 className="legal-section-title">
            5. Disclaimer of Warranties / Limitation of Liability
          </h2>
          <p>
            QSLOT has endeavoured to ensure that all the information on the
            QSLOT is correct, but QSLOT neither warrants nor makes any
            representations regarding the quality, accuracy or completeness of
            any data or information contained. QSLOT makes no warranty, express
            or implied, concerning the QSLOT and/or its contents and disclaims
            all warranties of fitness for a particular purpose and warranties of
            merchantability in respect of services, including any liability,
            responsibility or any other claim, whatsoever, in respect of any
            loss, whether direct or consequential, to any User or any other
            person, arising out of or from the use of the information contained
            in the QSLOT.
          </p>
          <p>
            Since QSLOT acts only as a booking agent, it shall not have any
            liability whatsoever for any aspect of the arrangements between the
            service provider and the User as regards the standards of services
            provided by the service providers. In no circumstances shall QSLOT
            be liable for the services provided by the service provider. Since
            QSLOT acts only as a Booking agent between the service provider and
            the User, QSLOT is not responsible or liable for any kind of harm or
            injury incurred by the User during his booking period or any other
            time period.
          </p>
          <p>
            Although QSLOT makes reasonable commercial efforts to ensure that
            the description and content in the TOS and on each page of the
            QSLOT is correct, it does not, however, take responsibility for
            changes that occurred due to human or data entry errors or for any
            loss or damages suffered by any User due to any information
            contained herein. Also, QSLOT is not the service provider and cannot
            therefore control or prevent changes in the published descriptions
            which are based upon information provided by the Service provider.
          </p>
          <p>
            QSLOT provides a platform enabling advertisers to create
            coupon/Offers to show/use by user and also Qslot (The APP) helps
            vendor (Service provider) to promote their shop/service by
            displaying adds in our App Platform. The Users are requested to
            verify the accuracy of all information on their own before
            undertaking any reliance on such information.
          </p>
          <p>
            In no event shall QSLOT be liable for any direct, indirect,
            punitive, incidental, special, consequential damages or any other
            damages resulting from:
          </p>
          <ul className="legal-list">
            <li>the use or the inability to use the services;</li>
            <li>
              the cost of procurement of substitute goods and services or
              resulting from any goods, information or services purchased or
              obtained or messages received or transactions entered into through
              the services;
            </li>
            <li>
              unauthorized access to or alteration of the User's transmissions
              or data;
            </li>
            <li>
              any other matter relating to the services; including, without
              limitation, damages for loss of use, data or profits, arising out
              of or in any way connected with the use or performance of the
              QSLOT.
            </li>
          </ul>
          <p>
            Neither shall QSLOT be responsible for the delay or inability to use
            the QSLOT or related services, the provision of or failure to
            provide services, or for any information, software, products,
            services and related graphics obtained through the QSLOT, or
            otherwise arising out of the use of the QSLOT, whether based on
            contract, tort, negligence, strict liability or otherwise. Further,
            QSLOT shall not be held responsible for non-availability of the
            QSLOT during periodic maintenance operations or any unplanned
            suspension of access to the QSLOT that may occur due to technical
            reasons or for any reason beyond QSLOT's control. The User
            understands and agrees that any material and/or data downloaded or
            otherwise obtained through the QSLOT is done entirely at their own
            discretion and risk and they will be solely responsible for any
            damage to their computer systems/ Mobile or any other form of
            electronic devices or loss of data that results from the download of
            such material and/or data. These limitations, disclaimer of
            warranties and exclusions apply without regard to whether the
            damages arise from (a) breach of contract, (b) breach of warranty,
            (c) negligence, or (d) any other cause of action, to the extent such
            exclusion and limitations are not prohibited by applicable law. The
            maximum liability on part of QSLOT arising under any circumstances,
            in respect of any services offered on the APP, shall be limited to
            the refund of total amount received from the customer for availing
            the services, less any cancellation, refund or others charges, as
            may be applicable. In no case the liability shall include any
            consequential loss, damage or additional expense whatsoever.
          </p>
        </section>

        {/* 6. Links to Third Party Sites */}
        <section className="legal-section">
          <h2 className="legal-section-title">6. Links to Third Party Sites</h2>
          <p>
            The QSLOT may contain links to other QSLOTs ("Linked Sites"). The
            Linked Sites are not under the control of QSLOT or the QSLOT and
            QSLOT is not responsible for the contents of any Linked Site,
            including without limitation any link contained in a Linked Site, or
            any changes or updates to a Linked Site. QSLOT is not responsible
            for any form of transmission, whatsoever, received by the User from
            any Linked Site. QSLOT is providing these links to the User only as
            a convenience, and the inclusion of any link does not imply
            endorsement by QSLOT or the QSLOT of the Linked Sites or any
            association with its operators or owners including the legal heirs
            or assigns thereof.
          </p>
          <p>
            QSLOT is not responsible for any errors, omissions or
            representations on any Linked Site. QSLOT does not endorse any
            advertiser on any Linked Site in any manner. The Users are requested
            to verify the accuracy of all information on their own before
            undertaking any reliance on such information.
          </p>
        </section>

        {/* 7. Prohibition Against Unlawful Use */}
        <section className="legal-section">
          <h2 className="legal-section-title">7. Prohibition Against Unlawful Use</h2>
          <p>
            As a condition of the use of the QSLOT, the User warrants that they
            will not use the QSLOT for any purpose that is unlawful or illegal
            under any law for the time being in force within or outside India or
            prohibited by this Agreement and/or the TOS including both specific
            and implied. In addition, the QSLOT shall not be used in any manner,
            which could damage, disable, overburden or impair it or interfere
            with any other party's use and/or enjoyment of the QSLOT. The User
            shall refrain from obtaining or attempting to obtain any materials
            or information through any means not intentionally made available or
            provided for or through the QSLOT.
          </p>
        </section>

        {/* 8. Use of Communication Services */}
        <section className="legal-section">
          <h2 className="legal-section-title">8. Use of Communication Services</h2>
          <p>
            The QSLOT may contain services such as email, chat, bulletin board
            services, information related to recommendations, news groups,
            forums, communities, personal web pages, calendars, and/or other
            message (hereinafter collectively referred to as "Communication
            Services"). The User agrees and undertakes to use the Communication
            Services only to post, send and receive messages and material that
            are proper and related to the particular Communication Service.
          </p>
          <p>
            By way of example, and not as a limitation, the User agrees and
            undertakes that when using a Communication Service, the User will
            not: defame, abuse, harass, stalk, threaten or otherwise violate the
            legal rights of others; upload files that contain software or other
            material protected by intellectual property laws unless the User
            owns or controls the rights thereto or have received all necessary
            consents; upload or distribute files that contain viruses, corrupted
            files, or any other similar software or programs that may damage the
            operation of the QSLOT or another's computer/mobile phones/ any
            other electronic devices; advertise or offer to sell or buy any
            goods or services for any business purpose, unless such
            Communication Service specifically allows such messages; conduct or
            forward surveys, contests, pyramid schemes or chain letters;
            download any file posted by another User of a Communication Service
            that the User know, or reasonably should know, cannot be legally
            distributed in such manner; falsify or delete any author
            attributions, legal or other proper notices or proprietary
            designations or labels of the origin or source of software or other
            material contained in a file that is uploaded; violate any code of
            conduct or other guidelines, which may be applicable for or to any
            particular Communication Service; violate any applicable laws or
            regulations for the time being in force in or outside India; and
            violate any of the terms and conditions of this Agreement or any
            other terms and conditions for the use of the QSLOT contained
            elsewhere herein.
          </p>
          <p>
            QSLOT has no obligation to monitor the Communication Services.
            However, QSLOT reserves the right to review materials posted through
            Communication Service and to remove any materials in its sole
            discretion. QSLOT reserves the right to terminate the User's access
            to any or all of the Communication Services at any time without
            notice for any reason whatsoever.
          </p>
          <p>
            QSLOT reserves the right at all times to disclose any information as
            is necessary to satisfy or comply with any applicable law,
            regulation, legal process or governmental request, or to edit,
            refuse to post or to remove any information or materials, in whole
            or in part, in QSLOT's sole discretion.
          </p>
          <p>
            QSLOT does not control or endorse the content, messages or
            information found in any communication service and, therefore,
            QSLOT specifically disclaims any liability or responsibility
            whatsoever with regard to the communication services and any actions
            resulting from the User's participation in any communication
            service.
          </p>
          <p>
            Materials uploaded to a Communication Service may be subject to
            posted limitations on usage, reproduction and/or dissemination.
            User is responsible for keeping himself updated of and adhering to
            such limitations if they download the materials.
          </p>
        </section>

        {/* 9. Termination */}
        <section className="legal-section">
          <h2 className="legal-section-title">9. Termination / Access Restriction</h2>
          <p>
            QSLOT reserves the right, in its sole discretion, to terminate the
            access to the QSLOT and the related services or any portion thereof
            at any time, without notice.
          </p>
        </section>

        {/* 10. Fees Payment */}
        <section className="legal-section">
          <h2 className="legal-section-title">10. Fees Payment</h2>
          <p>
            QSLOT reserves the right to charge listing fees for certain
            listings, as well as transaction fees based on certain completed
            transactions using the QSLOT Services. QSLOT further reserves the
            right to alter any and all fees from time to time, without notice.
          </p>
          <p>
            The User shall be liable to pay all applicable charges, fees,
            duties, taxes, levies and assessments for availing the QSLOT
            Services.
          </p>
        </section>

        {/* 11. User's Obligation */}
        <section className="legal-section">
          <h2 className="legal-section-title">11. User's Obligation and User Account</h2>
          <p>
            In consideration of use of the QSLOT, the User represent and confirm
            that the User is of legal age to enter into a binding contract and
            is not a person barred from using the QSLOT and/or receiving the
            Services under the laws of India or other applicable law.
          </p>
          <p>
            To avail a Service the User has and must continue to maintain at his
            sole cost:
          </p>
          <ul className="legal-list">
            <li>
              all the necessary equipment including a computer and modem etc/
              mobile phones/ any other E- devices to access the QSLOT/avail
              Services;
            </li>
            <li>
              own access to the World Wide Web/ App Store/ Play Store. The User
              shall be responsible for accessing the Services and that access
              may involve third party fees including, airtime charges or
              internet service provider's charges which are to be exclusively
              borne by the User.
            </li>
          </ul>
          <p>
            The User also understands that the services may include certain
            communications from QSLOT as service announcements and
            administrative messages. The User understands and agrees that the
            services are provided on an "as is" basis and that QSLOT does not
            assume any responsibility for deletions, mis-delivery or failure to
            store any User communications or personalized settings.
          </p>
          <p>
            Registration of the User on the QSLOT is mandatory. User Has to
            register themselves to use the App and their service. As
            registration process user must use the phone number to get OTP to
            login/Signup. User Will Not have option to set password. User will
            get OTP from the APP in the event of every login and first signup.
          </p>
          <p>
            The User agrees and undertakes at all times to be responsible for
            maintaining the confidentiality of the password/OTP and User id, and
            shall be fully responsible for all activities that occur by use of
            such password or User id. Further, the User agrees not to use any
            other party's User id and password for any purpose whatsoever
            without proper authorization from such party. The User is
            responsible for the security of your password/OTP and for all
            transactions undertaken using your password/OTP through our service.
            Thus the OTP will not be known even to QSLOT. You confirm that you
            are the authorised holder of the credit card or the original account
            holder used in the transactions you make using the QSLOT services.
            QSLOT will not be responsible for any financial loss, inconvenience
            or mental agony resulting from misuse of your ID/password/OTP
            /credit card number/account details number for using QSLOT Services.
          </p>
          <p>
            The User also agrees and undertakes to immediately notify QSLOT of
            any unauthorized use of the User id. QSLOT shall not be responsible
            for any, direct or indirect, loss or damage arising out of the
            User's failure to comply with this requirement.
          </p>
          <p>The User also agrees to:</p>
          <ul className="legal-list">
            <li>
              provide true, accurate and complete information about himself and
              his beneficiaries as prompted by the registration form
              ("Registration Data") on the QSLOT.
            </li>
            <li>
              maintain and promptly update the Registration Data to keep it
              true, accurate, current and complete. If the User provide any
              information that is untrue, inaccurate, not current or incomplete
              or QSLOT has reasonable grounds to suspect that such information
              is untrue, inaccurate, not current or incomplete, QSLOT has the
              right to suspend or terminate the User's registration and refuse
              any and all current or future use of the QSLOT and/or any Service.
            </li>
          </ul>
          <p>
            Furthermore, the User grants QSLOT the right to disclose to third
            parties Registration Data to the extent necessary for the purpose of
            carrying out the Services.
          </p>
        </section>

        {/* 12. Breach */}
        <section className="legal-section">
          <h2 className="legal-section-title">12. Breach</h2>
          <p>
            Without prejudice to the other remedies available to QSLOT under
            this agreement, the TOS or under applicable law, QSLOT may limit the
            User's activity, or end the User's listing, warn other Users of the
            User's actions, immediately temporarily/indefinitely suspend or
            terminate the User's registration, and/or refuse to provide the User
            with access to the QSLOT if:
          </p>
          <ul className="legal-list">
            <li>
              The User is in breach of this agreement, the TOS and/or the
              documents it incorporates by reference;
            </li>
            <li>
              QSLOT is unable to verify or authenticate any information provided
              by the User, or
            </li>
            <li>
              QSLOT believes that the User's actions may infringe on any third
              party rights or breach any applicable law or otherwise result in
              any liability for the User, other Users of the QSLOT and/or QSLOT.
            </li>
          </ul>
          <p>
            QSLOT may at any time in its sole discretion reinstate suspended
            Users. Once the User has been indefinitely suspended the User may
            not register or attempt to register with QSLOT or use the QSLOT in
            any manner whatsoever until such time that the User is reinstated by
            QSLOT. Notwithstanding the foregoing, if the User breaches this
            agreement, the TOS or the documents it incorporates by reference,
            QSLOT reserves the right to recover any amounts due and owing by the
            User to QSLOT and/or the service provider and to take strict legal
            action as QSLOT deems necessary.
          </p>
        </section>

        {/* 13. Proprietary Rights */}
        <section className="legal-section">
          <h2 className="legal-section-title">13. Proprietary Rights</h2>
          <p>
            QSLOT may provide the User with content such as sound, photographs,
            graphics, video or other material contained in sponsor
            advertisements or information. This material may be protected by
            copyrights, trademarks or other intellectual property rights and
            laws. The User may use this material only as expressly authorized by
            QSLOT and shall not copy, transmit or create derivative works of
            such material without express authorization from QSLOT.
          </p>
          <p>
            The User acknowledges and agrees that they shall not upload, post,
            reproduce or distribute any content on or through the QSLOT that is
            protected by copyright or other proprietary right of a third party,
            without obtaining the permission of the owner of such right. Any
            copyrighted or other proprietary content distributed on or through
            the QSLOT with the consent of the owner must contain the appropriate
            copyright or other proprietary rights notice. The unauthorized
            submission or distribution of copyrighted or other proprietary
            content is illegal and could subject the User to personal liability
            or criminal prosecution.
          </p>
        </section>

        {/* 14. Relationship */}
        <section className="legal-section">
          <h2 className="legal-section-title">14. Relationship</h2>
          <p>
            None of the provisions of this Agreement, terms and conditions,
            notices or the right to use the QSLOT by the User contained herein
            or any other section or pages of the QSLOT and/or the Linked Sites,
            shall be deemed to constitute a partnership between the User and
            QSLOT and no party shall have any authority to bind or shall be
            deemed to be the agent of the other in any way. It may be noted,
            however, that if by using the QSLOT, the User authorizes QSLOT and
            its agents to access third party sites designated by them or on
            their behalf for retrieving requested information, the User shall be
            deemed to have appointed QSLOT and its agents as their agent for
            this purpose.
          </p>
        </section>

        {/* 15. Headings */}
        <section className="legal-section">
          <h2 className="legal-section-title">15. Headings</h2>
          <p>
            The headings and subheadings herein are included for convenience and
            identification only and are not intended to describe, interpret,
            define or limit the scope, extent or intent of this Agreement, the
            TOS or the right to use the QSLOT by the User contained herein or
            any other section or pages of the QSLOT or any Linked Sites in any
            manner whatsoever.
          </p>
        </section>

        {/* 16. Interpretation */}
        <section className="legal-section">
          <h2 className="legal-section-title">16. Interpretation of Number and Genders</h2>
          <p>
            The terms and conditions herein shall apply equally to both the
            singular and plural form of the terms defined. Whenever the context
            may require, any pronoun shall include the corresponding masculine,
            feminine and Transgender. The words "include", "includes" and
            "including" shall be deemed to be followed by the phrase "without
            limitation". Unless the context otherwise requires, the terms
            "herein", "hereof", "hereto", "hereunder" and words of similar
            import refer to this Agreement as a whole.
          </p>
        </section>

        {/* 17. Indemnification */}
        <section className="legal-section">
          <h2 className="legal-section-title">17. Indemnification</h2>
          <p>
            The User agrees to indemnify, defend and hold harmless QSLOT from
            and against any and all losses, liabilities, claims, damages, costs
            and expenses (including legal fees and disbursements in connection
            therewith and interest chargeable thereon) asserted against or
            incurred by QSLOT that arise out of, result from, or may be payable
            by virtue of, any breach or non-performance of any representation,
            warranty, covenant or agreement made or obligation to be performed
            by the User pursuant to this Agreement and/or the TOS.
          </p>
        </section>

        {/* 18. Severability */}
        <section className="legal-section">
          <h2 className="legal-section-title">18. Severability</h2>
          <p>
            If any provision of this Agreement is determined to be invalid or
            unenforceable in whole or in part, such invalidity or
            unenforceability shall attach only to such provision or part of such
            provision and the remaining part of such provision and all other
            provisions of this Agreement shall continue to be in full force and
            effect.
          </p>
        </section>

        {/* 19. Termination of Agreement */}
        <section className="legal-section">
          <h2 className="legal-section-title">19. Termination of Agreement and Services</h2>
          <p>
            Either the User or QSLOT may terminate this Agreement and a Service
            with or without cause at any time to be effective immediately.
          </p>
          <p>
            The User agrees that QSLOT may under certain circumstances and
            without prior notice, immediately terminate the User's user id and
            access to the QSLOT/Services. Causes for termination may include,
            but shall not be limited to, breach by the User of this Agreement or
            the TOS, requests by enforcement or government agencies, requests by
            the User, non-payment of fees owed by the User in connection with
            the Services as specified in the applicable TOS.
          </p>
          <p>
            This Agreement may be terminated by either the User or QSLOT through
            a written notice to the other. QSLOT shall not be liable to the User
            or any third party for termination of any Service. Should the User
            object to any terms and conditions of this Agreement, any TOS or
            become dissatisfied with the Service in any way, the User's only
            recourse is to immediately:
          </p>
          <ul className="legal-list">
            <li>discontinue use of the QSLOT/Service.</li>
            <li>notify QSLOT of such discontinuance.</li>
          </ul>
          <p>
            Upon termination of the Service, User's right to use the
            QSLOT/Services and software shall immediately cease. The User shall
            have no right and QSLOT shall have no obligation thereafter to
            execute any of the User's uncompleted tasks or forward any unread or
            unsent messages to the User or any third party. Once the User's
            registration or the Services are terminated, cancelled or suspended,
            any data that the User has stored on the QSLOT may not be retrieved
            later.
          </p>
        </section>

        {/* 20. Notices */}
        <section className="legal-section">
          <h2 className="legal-section-title">20. Notices</h2>
          <p>
            All notices and communications (including those related to changes
            in the TOS, Service, termination of Service etc.,) shall be in
            writing, in English and shall deemed given if delivered personally
            or by commercial messenger or courier service, or mailed by
            registered or certified mail (return receipt requested) or sent via
            email/facsimile (with acknowledgment of complete transmission) to
            the following address:
          </p>
          <p>
            If to QSLOT, at contact{' '}
            <a href="mailto:support@queeslot.com">support@queeslot.com</a> or at
            the address posted on the QSLOT.
          </p>
          <p>
            If to a non-registered User, at the communication and/or email
            address specified in the application form availing of a QSLOT
            Service.
          </p>
          <p>
            If to a registered User, at the communication and/or email address
            specified in the registration form.
          </p>
          <p>
            Notice shall be deemed to have been served 48 hours after it has
            been sent, dispatched, displayed, as the case may be, unless, where
            notice has been sent by email, it comes to the knowledge of the
            sending party, that the email address is invalid.
          </p>
        </section>

        {/* 21. Governing Law */}
        <section className="legal-section">
          <h2 className="legal-section-title">21. Governing Law</h2>
          <p>
            This agreement and each TOS shall be governed by and constructed in
            accordance with the laws of India without reference to conflict of
            laws principles and disputes arising in relation hereto shall be
            subject to the exclusive jurisdiction of the courts of Coimbatore,
            Tamil Nadu, India.
          </p>
        </section>

        {/* 22. Purchase Policy */}
        <section className="legal-section">
          <h2 className="legal-section-title">22. Purchase Policy</h2>

          <h3 className="legal-subsection-title">22.1 Payment Methods</h3>
          <p>
            QSLOT accepts Visa, MasterCard, American Express, select Debit Cards
            and Net Banking. Other payment methods may be added from time to
            time.
          </p>
          <p>
            <strong>Who You Are Buying From:</strong> QSLOT acts as the Booking
            agent to those who are promoting the venues for which the User book
            Slots (Sports Venues/ car washing venues/Tournaments). When the User
            book's the Slot of a Sports/ car wash Venue/Tournaments, QSLOT will
            be handling the transaction and collecting payment for the Sports
            Venue/ car wash Venue/Tournaments.
          </p>

          <h3 className="legal-subsection-title">22.2 Pricing and Availability</h3>
          <p>
            QSLOT sells Slots on behalf of Sports Venues, Tournaments / Car Wash
            Venues and does not control the inventory or its availability and
            pricing.
          </p>
          <p>
            <strong>Internet handling fees and Order Processing Fees:</strong>{' '}
            Slots booked on QSLOT are subject to a per booking internet handling
            fee and a per order processing fee.
          </p>
          <p>
            <strong>Amount of Slots Per Customer or "Slot Limits":</strong>{' '}
            When purchasing Slots on QSLOT, the User is limited to a specified
            number of Slots for each booking.
          </p>

          <h3 className="legal-subsection-title">22.3 Order Confirmation</h3>
          <p>
            If the User does not receive a confirmation number (in the form of a
            confirmation page or email or SMS) after submitting payment
            information, or if you experience an error message or service
            interruption after submitting payment information, it is your
            responsibility to confirm the same form your booking history or with
            the Customer Service Department whether or not your order has been
            placed. Only you may be aware of any problems that may occur during
            the booking process. QSLOT will not be responsible for losses
            (monetary or otherwise) if you assume that an order was not placed
            because you failed to receive confirmation.
          </p>

          <h3 className="legal-subsection-title">22.4 Cancellation/Refund Policy</h3>
          <p>
            Before completing bookings, User must carefully review booking
            details. QSLOT will process refunds based on the booking
            information. The refund amount processed will be based on the
            difference in the Slot Date-Time and the current server Date-Time.
            The Refund Policy is only valid for Slots which are at a future
            Date-Time from the current Date-time of the server. No refund will
            be given for Slots past the current server Date-Time. Refund Amount
            will be decided as per mentioned in this terms.
          </p>
        </section>

        {/* 23. Cancellation Method and Charges */}
        <section className="legal-section">
          <h2 className="legal-section-title">23. Cancellation Method and Charges</h2>

          <h3 className="legal-subsection-title">23.1 Cancellation by Vendor</h3>
          <p>
            Vendors must comply policy to cancel a confirmed service (car wash
            or turf booking) through the QSLOT vendor dashboard or by notifying
            the Company and user via official communication channels (email or
            app support).
          </p>
          <p>Failure to comply with the minimum notice period may result in:</p>
          <ul className="legal-list">
            <li>The user will receive a full refund including the platform fee.</li>
            <li>Penalty Fee of up to 10% of the service value, and/or</li>
            <li>
              Temporary suspension of vendor listing on the platform for
              repeated violations.
            </li>
          </ul>

          <h4 className="legal-sub-sub-title">For TURF: (Cancellation Policy)</h4>
          <ul className="legal-list">
            <li>
              Vendors may cancel a user's booking only if the cancellation is
              made at least 2 hours prior to the scheduled slot time.
            </li>
            <li>
              A notification will be sent to the user with an option to either
              reschedule or Information about the cancellation of the booking.
            </li>
            <li>
              If the user chooses to reschedule, no charges will apply to the
              user, while the vendor will be charged 9% of the total booking
              amount.
            </li>
            <li>
              If the cancellation is accepted, the user will receive a full
              refund including the platform fee, and the vendor will be charged
              9% of the total booking amount as a cancellation fee.
            </li>
            <li>
              No Cancelation allowed to make if less than 2 hours from the
              scheduled slot time.
            </li>
          </ul>

          <h4 className="legal-sub-sub-title">For CAR WASH: (Cancellation Policy)</h4>
          <ul className="legal-list">
            <li>
              Vendors may cancel a user's booking only if the cancellation is
              made at least 1 hours prior to the scheduled slot time.
            </li>
            <li>
              If vendor cancel, the user will receive a full refund including
              the platform fee, and the vendor will be charged 9% of the total
              booking amount as a cancellation fee.
            </li>
            <li>
              No Cancelation allowed to make if less than 1 hours from the
              scheduled slot time.
            </li>
          </ul>

          <h3 className="legal-subsection-title">23.2 Cancellation by User</h3>
          <p>If a user cancels a booking:</p>

          <h4 className="legal-sub-sub-title">For TURF:</h4>
          <p>
            <strong>Cancellations 2 Hours or More Before the Scheduled Slot</strong>
          </p>
          <ul className="legal-list">
            <li>Platform fee is non-refundable.</li>
            <li>
              Full payment made: 95% of the full amount will be refunded to the
              user through the original payment method, while 5% will be
              retained by the app.
            </li>
            <li>
              Advance payment only: 75% of the advance payment will be refunded
              to the user through the original payment method while 25% will be
              retained by the app.
            </li>
          </ul>
          <p>
            <strong>Cancellations less than 2 hours Before the Scheduled Slot</strong>
          </p>
          <ul className="legal-list">
            <li>Platform fee is non-refundable.</li>
            <li>
              Full payment made: 80% of the full amount will be refunded to the
              user via the original mode of payment, 15% will be paid to the
              vendor, and 5% will be retained by the App.
            </li>
            <li>
              Advance payment only: 0% of the advance payment will be refunded
              to the user, 75% of the advance payment will be paid to the
              vendor, and 25% will be retained by the App.
            </li>
          </ul>
          <p className="legal-note">
            <strong>Note:</strong> Refund processing timelines will be 5 to 7
            business working days in accordance with the platform policy.
          </p>

          <h4 className="legal-sub-sub-title">For CAR WASH:</h4>
          <p>
            <strong>Cancellations 1 Hours or More Before the Scheduled Slot</strong>
          </p>
          <ul className="legal-list">
            <li>Platform fee is non-refundable.</li>
            <li>
              Full payment made: 95% of the full amount will be refunded to the
              user through the original payment method, while 5% will be
              retained by the app.
            </li>
            <li>
              Advance payment only: 75% of the advance payment will be refunded
              to the user through the original payment method while 25% will be
              retained by the app.
            </li>
          </ul>
          <p>
            <strong>Cancellations less than 1 hours Before the Scheduled Slot</strong>
          </p>
          <ul className="legal-list">
            <li>Platform fee is non-refundable.</li>
            <li>
              Full payment made: 80% of the Full amount will be refunded to the
              user via the original mode of payment, 15% will be paid to the
              vendor, and 5% will be retained by the App.
            </li>
            <li>
              Advance payment only: 0% of the amount will be refunded to the
              user, 75% of the advance amount will be paid to the vendor, and
              25% will be retained by the App.
            </li>
          </ul>
          <p className="legal-note">
            <strong>Note:</strong> Refund processing timelines will be 5 to 7
            business working days in accordance with the platform policy.
          </p>

          <h3 className="legal-subsection-title">
            23.3 Cancellation by Fewas Technologies Private Limited
          </h3>
          <p>
            Fewas Technologies Private Limited reserves the right to cancel any
            booking in the event of technical errors, fraud suspicion, or
            violation of terms, with or without notice.
          </p>
          <p>In such cases:</p>
          <ul className="legal-list">
            <li>Vendors shall not be charged any cancellation fee.</li>
            <li>
              If service preparation or material usage has already commenced,
              reasonable compensation may be considered at Fewas Technologies
              Private Limited discretion.
            </li>
          </ul>

          <h3 className="legal-subsection-title">23.4 Force Majeure</h3>
          <p>
            No cancellation charges shall apply in case of force majeure events
            (e.g., natural disasters, power failure, government restrictions)
            duly communicated and supported by valid evidence.
          </p>

          <h3 className="legal-subsection-title">23.5 Dispute Resolution</h3>
          <p>
            Any disputes regarding cancellation charges shall be reviewed by
            Fewas Technologies Private Limited. The Company's decision will be
            final and binding, unless otherwise governed by local laws.
          </p>
        </section>

        {/* 24. Rescheduling */}
        <section className="legal-section">
          <h2 className="legal-section-title">24. Rescheduling Method and Charges</h2>
          <p>
            Vendor is not allowed to reschedule the scheduled user slot.
          </p>

          <h3 className="legal-subsection-title">24.1 Rescheduling by User</h3>

          <h4 className="legal-sub-sub-title">For CAR WASH</h4>
          <p>
            Users may request to reschedule a service under the following
            conditions:
          </p>
          <ul className="legal-list">
            <li>
              Users may reschedule their booking once only, and free of charge,
              provided the request is made at least 1 hours prior to the
              scheduled slot time within the same day.
            </li>
            <li>
              Once a booking has been rescheduled, no further cancellations or
              modifications will be permitted
            </li>
            <li>No reschedule option given to reschedule a book for next day</li>
          </ul>

          <h4 className="legal-sub-sub-title">For TURF</h4>
          <p>
            Users may request to reschedule a service under the following
            conditions:
          </p>
          <ul className="legal-list">
            <li>
              Users may reschedule their booking once only, and free of charge,
              provided the request is made at least 2 hours prior to the
              scheduled slot time.
            </li>
            <li>
              A Booking Only allowed Reschedule with the same turf and same
              game, subject to available slots
            </li>
            <li>
              Once a booking has been rescheduled, no further cancellations or
              modifications will be permitted.
            </li>
          </ul>

          <h3 className="legal-subsection-title">
            24.2 Rescheduling by Fewas Technologies Private Limited
          </h3>
          <p>
            Fewas Technologies Private Limited may reschedule services in rare
            cases such as system outages, vendor unavailability, or in the
            interest of service quality and customer satisfaction.
          </p>
          <p>In such cases:</p>
          <ul className="legal-list">
            <li>
              Users and vendors will be notified at the earliest possible time.
            </li>
            <li>
              No charges shall apply to either party, and alternate options may
              be provided.
            </li>
          </ul>

          <h3 className="legal-subsection-title">24.3 Notification and Confirmation</h3>
          <p>
            All rescheduling requests must be confirmed via the Fewas
            Technologies Private Limited mobile application, vendor dashboard,
            or official written communication (email/SMS).
          </p>
          <p>
            Services are considered successfully rescheduled only upon receipt
            of confirmation from the system or Fewas Technologies Private
            Limited support team.
          </p>

          <h3 className="legal-subsection-title">24.4 Dispute Handling</h3>
          <p>
            In the event of a disagreement regarding rescheduling charges or
            terms, the matter shall be reviewed and resolved by Fewas
            Technologies Private Limited. The Company's decision shall be final
            and binding.
          </p>

          <h3 className="legal-subsection-title">24.5 Additional Conditions</h3>
          <ul className="legal-list">
            <li>
              If a user fails to show up for the slot and doesn't respond within
              15 minutes of the scheduled time, the vendor may reassign the slot.
            </li>
            <li>Clause 1 does not apply to users who paid the full amount.</li>
            <li>
              No refund will be provided if a user fails to show up for the
              scheduled slot time
            </li>
            <li>
              Qslot (Fewas Technologies) is not responsible for any offline
              arrangements between vendor and user.
            </li>
          </ul>
        </section>

        {/* 25. Refund Method */}
        <section className="legal-section">
          <h2 className="legal-section-title">25. Refund Method / Mode &amp; Timeline</h2>
          <ul className="legal-list">
            <li>
              Refunds to bank accounts, cards or original mode of payment (UPI,
              Credit/Debit Card) typically take 5–7 business days.
            </li>
            <li>
              Refund status can be tracked in the "My Bookings" section of the
              app.
            </li>
          </ul>
        </section>

        {/* 26. Exceptions */}
        <section className="legal-section">
          <h2 className="legal-section-title">26. Exceptions</h2>
          <ul className="legal-list">
            <li>
              Special cancellation terms may apply for bulk bookings, seasonal
              tournaments, or partner promotions. These will be clearly
              mentioned at the time of booking.
            </li>
            <li>
              For technical issues during booking or duplicate charges, users
              can contact support for a full resolution and refund.
            </li>
          </ul>
        </section>

        {/* 27. How to Cancel */}
        <section className="legal-section">
          <h2 className="legal-section-title">27. How to Cancel or Modify a Booking</h2>
          <p>To cancel or reschedule:</p>
          <ol className="legal-ordered-list">
            <li>Open The App.</li>
            <li>Go to "My Bookings".</li>
            <li>Select the booking you wish to modify.</li>
            <li>Choose "Cancel" or "Reschedule" and follow the instructions.</li>
          </ol>
          <p>
            For Queries in cancellations/Reschedule, please contact customer
            support via the app or at{' '}
            <a href="mailto:support@queeslot.com">support@queeslot.com</a>
          </p>
          <p>
            By accepting the Terms and Conditions, the User accepts the Refund
            Policy.
          </p>
          <p>
            At QSLOT, we strive to provide a smooth and user-friendly experience
            for all players, car wash customers, players of Turf Tournaments and
            turf/Car wash/Tournament partners. This Refund Policy outlines the
            terms under which users are eligible for refunds and how such
            refunds will be processed.
          </p>
        </section>

        {/* 28. Technical Failures */}
        <section className="legal-section">
          <h2 className="legal-section-title">28. Technical Failures or Payment Errors</h2>
          <p>In cases where:</p>
          <ul className="legal-list">
            <li>A payment is debited but the booking fails,</li>
            <li>A double payment is made,</li>
            <li>Or system errors lead to booking issues,</li>
          </ul>
          <p>
            Users will be eligible for a full refund of the affected transaction.
          </p>
        </section>

        {/* 29. Non-Refundable */}
        <section className="legal-section">
          <h2 className="legal-section-title">29. Non-Refundable Scenarios</h2>
          <p>Refunds will not be provided under the following circumstances:</p>
          <ul className="legal-list">
            <li>
              <strong>No-show:</strong> If the user does not show up for the
              booking and fails to cancel in advance.
            </li>
            <li>
              <strong>Late cancellation:</strong> Cancellations made outside the
              free cancellation or partial refund window as outlined in our
              Cancellation Policy.
            </li>
            <li>
              <strong>Violation of terms:</strong> If the user is found in
              breach of platform or venue rules (e.g., misconduct, misuse of
              turf, etc.).
            </li>
          </ul>
          <p>
            If the user is found to be in breach of platform or service rules
            (e.g., misconduct, misuse of service, fraudulent activities), the
            following actions may be taken:
          </p>
          <ul className="legal-list">
            <li>
              <strong>Misuse of Vehicle Details:</strong> Providing incorrect or
              fraudulent vehicle information for booking or availing of services.
            </li>
            <li>
              <strong>Improper Conduct at Service Location:</strong> Any unruly,
              abusive, or disrespectful behaviour towards the service provider
              or damage to their property/tools.
            </li>
            <li>
              <strong>Tampering with Equipment:</strong> Unauthorized handling
              or interference with washing equipment or tools.
            </li>
            <li>
              <strong>No-Show Without Notice:</strong> Repeated instances of
              confirmed bookings with failure to show up without any prior
              cancellation or rescheduling.
            </li>
            <li>
              <strong>Unauthorized Service Requests:</strong> Requesting or
              coercing the service provider to perform tasks outside the agreed
              package or scope of service.
            </li>
            <li>
              <strong>Disregard for Hygiene/Safety Protocols:</strong> Violating
              any health, safety, or hygiene policies set by the platform or
              service provider.
            </li>
          </ul>

          <h4 className="legal-sub-sub-title">
            Turf Tournament – Violation of Terms
          </h4>
          <p>
            If the user (player, team, or organizer) is found in breach of
            platform or tournament rules, the following may apply:
          </p>
          <ul className="legal-list">
            <li>
              <strong>Inappropriate Behaviour:</strong> Verbal or physical
              misconduct, harassment, or abusive behaviour towards other
              participants, referees, organizers, or staff.
            </li>
            <li>
              <strong>Match Fixing or Cheating:</strong> Engaging in any form of
              match-fixing, unfair play, or cheating during the tournament.
            </li>
            <li>
              <strong>Unauthorized Player Substitution:</strong> Including
              unregistered or ineligible players in the team or changing team
              composition without prior approval.
            </li>
            <li>
              <strong>Violation of Tournament Rules:</strong> Ignoring or
              wilfully breaking match regulations, game timing, dress code, or
              conduct guidelines set forth by the organizers.
            </li>
            <li>
              <strong>Vandalism or Damage to Venue:</strong> Damaging turf
              property, equipment, or any part of the venue infrastructure.
            </li>
            <li>
              <strong>Failure to Follow Instructions:</strong> Refusal to
              comply with instructions from tournament officials or event
              coordinators.
            </li>
          </ul>
        </section>

        {/* 30. Dispute Resolution */}
        <section className="legal-section">
          <h2 className="legal-section-title">30. Dispute Resolution &amp; Refund Appeals</h2>
          <p>
            If a user disagrees with the outcome of a cancellation or refund
            decision, they may:
          </p>
          <ul className="legal-list">
            <li>
              Email the full details to{' '}
              <a href="mailto:support@queeslot.com">support@queeslot.com</a>{' '}
              within 72 hours of the issue.
            </li>
            <li>
              Provide relevant screenshots, transaction IDs, or booking
              references.
            </li>
            <li>
              Our support team will review the request and respond within 3
              working days.
            </li>
          </ul>
        </section>

        {/* 31. Force Majeure */}
        <section className="legal-section">
          <h2 className="legal-section-title">31. Force Majeure</h2>
          <p>
            In case of cancellations due to events beyond control (e.g., natural
            disasters, government-imposed restrictions, pandemics, etc.),
            refund eligibility will be evaluated based on the situation. Where
            applicable, users may receive full or partial refunds, or reschedule
            options.
          </p>
        </section>

        {/* 32. Promotions */}
        <section className="legal-section">
          <h2 className="legal-section-title">32. Promotions, Discounts &amp; Vouchers</h2>
          <p>
            Refunds on bookings made using promo codes, discounts, or gift
            vouchers:
          </p>
          <ul className="legal-list">
            <li>
              Only the actual amount paid (excluding discounts) will be refunded.
            </li>
            <li>
              Promo codes or coupons used during the original booking will not
              be reissued unless specifically stated.
            </li>
          </ul>
        </section>

        {/* 33. Refund Tracking */}
        <section className="legal-section">
          <h2 className="legal-section-title">33. Refund Tracking</h2>
          <p>Users can track the status of their refunds by:</p>
          <ul className="legal-list">
            <li>Visiting My Bookings in the app.</li>
            <li>Contacting our support team via chat or email.</li>
          </ul>
        </section>

        {/* 34. Late Arrivals */}
        <section className="legal-section">
          <h2 className="legal-section-title">34. Late Arrivals</h2>
          <p>
            QSLOT advises the users to arrive 15 minutes in advance of the
            scheduled Slot time. The Sports Venue reserves the right to cancel
            your booking and allocate the Ground to other guests in case of late
            arrivals and QSLOT shall in no manner be liable for such
            cancellation initiated by the Sports Venue. The App has no
            responsible for if an user misses car service slot or an user misses
            tournament on time.
          </p>
        </section>

        {/* 35. Email Confirmation */}
        <section className="legal-section">
          <h2 className="legal-section-title">35. Email Confirmation</h2>
          <p>
            Your booking confirmation will be sent via an email. This
            confirmation needs to be printed and/or shown at the Sports Venue,
            Tournaments / Car Wash Venue to get access to your booked
            Ground/Service.
          </p>
        </section>

        {/* 36. SMS Confirmation */}
        <section className="legal-section">
          <h2 className="legal-section-title">36. SMS Confirmation</h2>
          <p>
            Your booking confirmation will be sent via an SMS/App Notification.
            The SMS details need to be shown at the Sports Venue, Tournaments /
            Car Wash Venue to get access to your booked Ground/Service.
          </p>
          <p>
            In case you experience any problems please call our helpdesk (On the
            Homepage) for assistance.
          </p>
          <p>
            <strong>Cancelled Venues:</strong> Occasionally, Sports Venue,
            Tournaments / Car Wash Venue may cancel bookings due to certain
            reasons. Should this occur, we will attempt to contact you or notify
            through app notification/SMS/Email and refund the amount as per our
            policy.
          </p>
        </section>

        {/* 37. Buyer Beware */}
        <section className="legal-section">
          <h2 className="legal-section-title">37. Buyer Beware</h2>
          <p>Read Through our Terms and Conditions Carefully.</p>
          <ul className="legal-list">
            <li>
              Accepting the Terms and conditions while booking Slot(s) online
              makes it a valid contract between the User and the QSLOT.
            </li>
            <li>
              Booking Id's generated only through back end process of QSLOT
              shall be considered by us as a valid Booking Id.
            </li>
            <li>
              Ensure the personal details entered including the card details are
              accurate. Booking Id's once generated cannot be
              cancelled/refunded/exchanged.
            </li>
            <li>
              Ensure the Booking Id's are kept safe and always in your or such
              person's possession who is considered as your authorized/rightful
              holder of the same. Anybody in possession of the Booking Id shall
              be entitled to get the same exchanged for a valid Ticket without
              further security checks on the title of such holder.
            </li>
            <li>Ensure that the Booking Id's are not compromised or resold.</li>
            <li>
              Do not entertain any person who sells sms of Booking Id's
              generated by us. If you come across any person undertaking such
              activity, immediately report the same to the local police station
              and to us.
            </li>
            <li>
              We never sell a Slot at a price higher than the price mentioned in
              our QSLOT.
            </li>
            <li>
              We will never ask for your Personal Identification Number (PIN)
              details over the phone or through any means except through the
              transaction page on the QSLOT when you book online.
            </li>
            <li>
              Do not encourage any persons posing as our authorised
              representative/agent trying to sell you special offer
              voucher/gift vouchers/physically printed booking id's/win
              pins/voucher encodes etc. Report the same immediately to us at.
            </li>
            <li>
              Booking Id's generated by us entitles the holder to exchange it
              for access to their Ground, Tournaments / car wash venues.
            </li>
            <li>
              Booking Id's generated entitled the holder thereof access to the
              playing area of the Sports Venue, Tournaments / car wash venues.
            </li>
            <li>
              It is your responsibility to ensure that the holder is the
              rightful holder of the same. Do not compromise or misuse the
              Booking ID's.
            </li>
          </ul>
        </section>

        {/* 38. Prohibited Equipment */}
        <section className="legal-section">
          <h2 className="legal-section-title">38. Prohibited Electronic Equipment</h2>
          <p>
            Customers are advised to avoid carrying Laptops, Handycams, iPads,
            Tablets and Digital Cameras to the Sports Venues, Tournaments / car
            wash venues.
          </p>
          <p>
            QSLOT are not liable or responsible in the event of theft or loss of
            any property.
          </p>
        </section>

        {/* 39. Notice & Take Down */}
        <section className="legal-section">
          <h2 className="legal-section-title">39. Notice &amp; Take Down Policy</h2>
          <p>
            AS AN INTERMEDIARY, QSLOT IS NOT LIABLE FOR ANY THIRD-PARTY CONTENT
            UPLOADED, TRANSMITTED, DISPLAYED, PUBLISHED OR SHARED ON ITS
            PLATFORM. BY USING QSLOT APP, YOU AGREE TO THE CONDITIONS SET OUT IN
            THIS NOTICE AND TAKE DOWN POLICY.
          </p>
        </section>

        {/* 40. Copyright Infringement */}
        <section className="legal-section">
          <h2 className="legal-section-title">40. Copyright Infringement Notification</h2>
          <p>
            If the owner of a copyright-protected work or an agent authorized to
            act on the copyright owner's behalf (the "Owner") believes the work
            posted on QSLOT is infringing the Owner's copyright under the
            relevant law, the Owner may submit a copyright infringement
            notification.
          </p>
        </section>

        {/* 41. Copyright Procedure */}
        <section className="legal-section">
          <h2 className="legal-section-title">41. Copyright Infringement Notification Procedure</h2>
          <p>
            QSLOT recommends Owners of copyright-protected content to report
            alleged copyright infringement by submitting a written complaint
            (the "Complaint") either through a web-form (recommended) or through
            email on{' '}
            <a href="mailto:support@queeslot.com">support@queeslot.com</a>. The
            Complaint should include the following:
          </p>
          <ul className="legal-list">
            <li>
              <strong>Contact Information:</strong> The Owner will need to
              provide information that will allow QSLOT and the uploader(s) of
              the video(s) that the Owner's objects to, to contact the Owner
              regarding the Complaint, such as an email address, physical
              address or telephone number.
            </li>
            <li>
              <strong>Description of Work:</strong> The Owner's must provide in
              the complaint, a complete and accurate description of the
              copyrighted content that the Owner is seeking to protect. This
              MUST also include the specific URL of the content/video that the
              Owner believes to be infringing. This is necessary in order to aid
              QSLOT to locate the allegedly infringing content/video. General
              information about the video, such as a channel URL or username
              alone is not adequate. The URL should be in the proper format.
            </li>
            <li>
              <strong>Necessary Format:</strong> The Complaint should include
              the following statements – "I have a good faith belief that the
              use of the material in the manner complained of is not authorized
              by the copyright owner, its agent, or the law." AND "The
              information in this notification is accurate, and I am the owner,
              or an agent authorized to act on behalf of the owner, of an
              exclusive right that is allegedly infringed."
            </li>
            <li>
              <strong>Signature:</strong> The Complaint must include the
              physical or electronic signature/digital signature of the Owner.
              To satisfy this requirement, the Owner may type their full legal
              name (a first and last name, not a company name) as the signature
              at the bottom of the complaint.
            </li>
          </ul>
        </section>

        {/* 42. Take-Down */}
        <section className="legal-section">
          <h2 className="legal-section-title">42. Take-Down of Copyright Infringing Work</h2>
          <p>
            In case of a Complaint by the Owner that is submitted in accordance
            with the procedure in Clause 2, and found to be valid, QSLOT may
            refrain from facilitating access to the allegedly infringing work
            for a period of 21 (twenty-one) days or until an order from a
            competent court is received, whichever is earlier. In case QSLOT
            receives no such order before the expiry of twenty-one days, QSLOT
            may reinstate access to the said work.
          </p>
        </section>

        {/* 43. Objectionable Content */}
        <section className="legal-section">
          <h2 className="legal-section-title">43. Notification of Objectionable Content and Take Down</h2>
          <p>
            Users may submit a complaint against objectionable content by
            submitting a written complaint (the "Complaint") either through a
            web-form (recommended) or through email on{' '}
            <a href="mailto:support@queeslot.com">support@queeslot.com</a>. The
            Complaint should include the following:
          </p>
          <ul className="legal-list">
            <li>
              <strong>Contact Information:</strong> The Complainant will need to
              provide information that will allow QSLOT to contact the
              Complainant regarding the Complaint, such as an email address,
              physical address or telephone number.
            </li>
            <li>
              <strong>Description of Work:</strong> The Complainant must provide
              in the complaint, a description of the objectionable content that
              the Complainant is seeking to protest. This MUST also include the
              specific URL of the video that the Complainant believes to be
              objectionable. This is necessary in order to aid QSLOT to locate
              the allegedly objectionable video. General information about the
              video, such as a channel URL or username alone shall not be
              adequate. The URL should be in the protect format.
            </li>
            <li>
              <strong>Necessary Format:</strong> The Complaint should include
              the following statements – "I have a good faith belief that the
              use of the material in the manner complained of violates any law,
              or the conditions in Clause 4 of QSLOT's Notice and Take Down
              Policy" AND "The information in this notification is accurate to
              my knowledge".
            </li>
          </ul>
          <p>
            If QSLOT determines, in its sole discretion and judgment, that the
            User Content violates any of the aforementioned conditions, it
            shall be entitled to immediately take down or otherwise block
            access to User Content.
          </p>
        </section>

        {/* 44. Immunity */}
        <section className="legal-section">
          <h2 className="legal-section-title">44. QSLOT's Immunity from Liability</h2>
          <p>
            QSLOT is an intermediary and shall not be liable for any act of
            copyright infringement or any other objectionable User Content, as
            provided under the Copyright Act, 1957, Information Technology Act,
            2000 and Rules thereunder.
          </p>
        </section>

        {/* 45. Pickup Service */}
        <section className="legal-section">
          <h2 className="legal-section-title">45. Pickup Service Responsibilities &amp; Limitations</h2>
          <p>
            The App facilitates a service wherein registered vendor (service
            providers) may offer vehicle pickup and wash services directly to
            users. While the platform enables this feature for the convenience
            of both parties, the following responsibilities and disclaimers
            shall apply:
          </p>

          <h3 className="legal-subsection-title">45.1 Vendor Pickup Service</h3>
          <p>
            Certain vendors may provide an option to pick up the user's vehicle,
            perform the car wash service at an offsite location, and return the
            vehicle upon completion. This offering is solely managed by the
            vendor and is not directly operated or supervised by the App.
          </p>

          <h3 className="legal-subsection-title">45.2 User Responsibility</h3>
          <p>
            Before handing over the vehicle to any vendor, it is the sole
            responsibility of the user to verify the identity, credibility, and
            trustworthiness of the service provider. The App strongly
            recommends users to:
          </p>
          <ul className="legal-list">
            <li>
              Confirm the vendor's credentials and service history via the
              platform.
            </li>
            <li>
              Take note of the vendor's contact information and photo ID (if
              applicable).
            </li>
            <li>
              Record the vehicle's condition (including photos) before handing
              it over.
            </li>
          </ul>

          <h3 className="legal-subsection-title">45.3 Limitation of Liability</h3>
          <p>
            The App acts solely as an intermediary platform that connects users
            with service providers. As such, the App shall not be held liable or
            responsible for any damage to, accident, loss of, or theft
            involving the user's vehicle during the pickup, servicing, or return
            process. Any disputes, claims, or grievances arising from the use of
            the pickup service must be addressed directly between the user and
            the vendor.
          </p>

          <h3 className="legal-subsection-title">45.4 User Acknowledgment</h3>
          <p>
            By opting for a pickup-based service, the user acknowledges and
            agrees to accept full responsibility for any risk involved in
            handing over their vehicle to a third-party vendor.
          </p>
        </section>

        {/* 46. Images */}
        <section className="legal-section">
          <h2 className="legal-section-title">46. Use of Purchased Images and Visual Assets</h2>
          <p>
            To enhance the visual appeal and user experience of the App, we
            utilize high-quality images and design elements across various
            sections of the platform. This includes, but is not limited to,
            images related to sports, cars, turfs, car logos, and other thematic
            visuals.
          </p>

          <h3 className="legal-subsection-title">46.1 Licensed Image Sources</h3>
          <p>
            The App obtains these visual assets from reputable and legally
            compliant third-party platforms such as Envato Elements, Canva Pro,
            and other licensed stock image providers. These platforms provide
            images, graphics, and illustrations under commercial-use licenses,
            allowing integration into mobile applications, websites, and digital
            products.
          </p>

          <h3 className="legal-subsection-title">46.2 Scope of Use</h3>
          <p>
            The images purchased and used within the App are intended solely for
            display, decorative, and illustrative purposes. Examples include:
          </p>
          <ul className="legal-list">
            <li>
              Showcasing categories (e.g., car wash services, turf bookings).
            </li>
            <li>Enhancing UI/UX design elements within the App interface.</li>
            <li>Supporting promotional banners or service descriptions.</li>
          </ul>
          <p>
            These visuals are not used to imply any brand endorsement,
            affiliation, or sponsorship, unless explicitly stated.
          </p>

          <h3 className="legal-subsection-title">46.3 Use of Brand Logos and Trademarks</h3>
          <p>
            In cases where brand logos (e.g., car manufacturers) are displayed
            for categorization or identification purposes (such as selecting a
            car brand for a wash), such use is strictly illustrative and
            non-commercial in intent. All logos remain the intellectual property
            of their respective trademark holders. The App does not claim any
            ownership or endorsement rights over such logos.
          </p>

          <h3 className="legal-subsection-title">46.4 User and Vendor Clarification</h3>
          <p>
            Users and vendors interacting with the App should understand that
            the images and logos used within the App are intended purely for
            service guidance and interface enhancement. They are not
            representative of actual vehicles, turf locations, or direct
            business partnerships unless clearly indicated.
          </p>
        </section>

        {/* 47. Disclaimer */}
        <section className="legal-section">
          <h2 className="legal-section-title">47. Disclaimer on Use of Logos and Open-Source Materials</h2>
          <p>
            Fewas Technologies Private Limited may display logos, brand names, or
            visual representations of various automobile manufacturers and may
            also use publicly available or open-source files solely for the
            limited purpose of indicating that our car wash services are
            available for vehicles of such brands. We expressly disclaim any
            ownership, affiliation, endorsement, sponsorship, or partnership
            with such automobile manufacturers or brands. All trademarks, logos,
            and intellectual property rights remain the exclusive property of
            their respective owners. Our use of such materials is purely
            nominative and informational, intended only to make the public aware
            of the availability of our services, and does not confer upon Fewas
            Technologies Private Limited any claim of rights, title, or interest
            in such intellectual property.
          </p>
        </section>

        {/* Contact */}
        <section className="legal-section">
          <h2 className="legal-section-title">Contact Information</h2>
          <p>
            If you have any questions or concerns about these Terms of Use,
            please contact us directly.
          </p>
          <ul className="legal-contact-list">
            <li>
              <strong>Email:</strong>{' '}
              <a href="mailto:support@queeslot.com">support@queeslot.com</a>
            </li>
            <li>
              <strong>Phone:</strong> <a href="tel:9280084952">9280084952</a>
            </li>
          </ul>
        </section>
      </main>
    </div>
  );
};

export default TermsAndConditions;